class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]')?.addEventListener(
      'click',
      this.close.bind(this)
    );
    this.querySelector('.modal-overlay')?.addEventListener('click', this.close.bind(this))

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    window.searchOpen = true;
    event.preventDefault();
    event.stopPropagation();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {

    if (this.classList.contains('header__search') && window.innerWidth < 750) {
      return null;
    }

    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    window.searchOpen = false;
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.querySelector('html').classList.remove(`overflow-hidden`);
    setTimeout(() => {
      console.log('wait to display');
      document.querySelector('.section-header .announcement-bar-container').style.opacity = 0;
      document.querySelector('.section-header .announcement-bar-container').style.opacity = 1;
      document.querySelector('body').style.overflowY = 'unset';

      document.querySelector('body').style.overflowY = 'auto';
      document.querySelector('html').style.overflowY = 'unset';

      document.querySelector('html').style.overflowY = 'auto';
    }, 500);
  }
}

customElements.define('details-modal', DetailsModal);
